import React from 'react';
import './index.css';

const NotSupportedScreenSize = () => {
    return (
        <div className="not-supported-screen-size">
            <div>It seems that your screen size is not supported :(</div>
            <div>
                Try rotating your phone or refreshing the page and if the
                problem persits contact support
            </div>
        </div>
    );
};

export { NotSupportedScreenSize };
export default NotSupportedScreenSize;
